import React, { memo, useContext } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import GenerateArea from 'Pods/ThreeDStudio/Shared/GenerateArea/GenerateArea'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import ComingSoon from './Components/ComingSoon/ComingSoon'
import PromptField from './Components/PromptField/PromptField'
import StyleField from './Components/StyleField/StyleField'

// The render endpoint does not exist yet, so the action stays disabled whatever the form
// holds. Flip this once the backend accepts the run; the form-completeness rule below is
// what governs the button from then on.
const IS_RENDER_BACKEND_READY = false

function RenderTab() {
  const t = useTranslation()
  const { enable2dRender } = useContext(ThreeDStudioPageContext)
  const prompt = useThreeDStudioStore(state => state.renderSettings.prompt)
  const style = useThreeDStudioStore(state => state.renderSettings.style)
  // A render needs something to go on: either the free-text prompt or a picked style.
  // Whitespace alone is not a prompt.
  const isMissingRequiredParams = !prompt?.trim() && !style

  if (!enable2dRender) {
    return <ComingSoon />
  }

  return (
    <>
      <div className="render-tab enhance-model-panel__tab">
        <span className="enhance-model-panel__title cgt-heading-50">
          {t('viewerSidebar.enhance.render.title')}
        </span>
        <p className="render-tab__hint cgt-body-base">
          <img
            className="render-tab__hint-icon"
            src="/assets/three_d_studio/render_tab/mouse.svg"
            alt=""
            aria-hidden="true"
            width={16}
            height={16}
          />
          {t('viewerSidebar.enhance.render.viewerHint')}
        </p>
        <div className="enhance-model-panel__settings">
          <PromptField />
          <StyleField />
        </div>
      </div>
      <GenerateArea
        generateLabel={t('viewerSidebar.enhance.render.generateLabel')}
        generatedLabel={t('viewerSidebar.enhance.common.done')}
        generatingLabel={t('viewerSidebar.enhance.common.processing')}
        isEnhancementMode
        isGenerateDisabled={!IS_RENDER_BACKEND_READY || isMissingRequiredParams}
        withIcon={false}
      />
    </>
  )
}

export default memo(RenderTab)
